import router from '@/router';
import { getError } from '@/utils/helpers';
import AuthService from '@/services/AuthService';

export default {
  logout({ commit, dispatch }) {
    return AuthService.logout()
      .then(() => {
        commit('SET_USER', null);
        dispatch('setGuest', { value: 'isGuest' });
        if (router.currentRoute.name !== 'login') {
          router.push({ path: '/login' });
        }
      })
      .catch((error) => {
        commit('SET_ERROR', error);
      });
  },
  async getAuthUser({ commit }) {
    commit('SET_LOADING', true);
    try {
      const response = await AuthService.getAuthUser();
      commit('SET_USER', response.data);
      //console.log(response.data);
      //commit('website/SET_WEBSITE', response.data.current_team.website, { root:true })
      commit('SET_LOADING', false);
      return response.data;
    } catch (error) {
      commit('SET_LOADING', false);

      const status = error && error.response && error.response.status;
      if (status === 401 || status === 419) {
        commit('SET_USER', null);
      }

      return null;
    }
  },
  setGuest(context, { value }) {
    window.localStorage.setItem('guest', value);
  },
};
